export const isMultilineTextTrimmed = (
  element: HTMLElement | null,
  heightTolerance = 0,
) => {
  if (!element) return false;

  const elementClientHeight = element.clientHeight + heightTolerance;

  return (
    element.scrollHeight > elementClientHeight ||
    element.scrollWidth > element.clientWidth
  );
};
